export const DataFields = (t) => {
  return [
    {
      name: "",
      fields: [
        {
          id: "size",
          name: t('qrcode_style_form_size'),
          type: "number",
          required: true,
          defaultValue: 300,
          inputProps: { min: 100, max: 2000 },
          endAdornment: { value: "px" },
          startAdornment: null,
          size: "small"
        },
        {
          id: "margin",
          name: t('qrcode_style_form_margin'),
          type: "number",
          required: true,
          defaultValue: 300,
          inputProps: { min: 0, max: 50 },
          endAdornment: { value: "px" },
          startAdornment: null,
          size: "small"
        },
        {
          id: "image",
          name: t('qrcode_style_form_image'),
          type: "image",
          required: false,
          isImage: true,
          defaultValue: "",
          size: "small"
        },
        {
          id: "background",
          name: t('qrcode_style_form_background'),
          type: "color",
          required: true,
          defaultValue: "#ffffff",
          size: "small"
        },
        {
          id: "points_style",
          name: t('qrcode_style_form_points_style'),
          type: "select",
          containerOptions: "points_style",
          required: true,
          defaultValue: "",
          size: "small"
        },
        {
          id: "points_color",
          name: t('qrcode_style_form_points_color'),
          type: "color",
          required: true,
          defaultValue: "#ffffff",
          size: "small"
        },
        {
          id: "corners_square_style",
          name: t('qrcode_style_form_corners_square_style'),
          type: "select",
          containerOptions: "corners_square_style",
          required: true,
          defaultValue: "",
          size: "small"
        },
        {
          id: "corners_square_color",
          name: t('qrcode_style_form_corners_square_color'),
          type: "color",
          required: true,
          defaultValue: "#ffffff",
          size: "small"
        },
        {
          id: "corners_dot_style",
          name: t('qrcode_style_form_corners_dot_style'),
          type: "select",
          containerOptions: "corners_dot_style",
          required: true,
          defaultValue: "",
          size: "small"
        },
        {
          id: "corners_dot_color",
          name: t('qrcode_style_form_corners_dot_color'),
          type: "color",
          required: true,
          defaultValue: "#ffffff",
          size: "small"
        }
      ]
    }
  ]
}